export const PAGE_SIZE = 10;
const SPEND_COL_MIN_WIDTH = 111;

export const getColumnDefs = (
	companies,
	spendFormatter,
	sortModel,
	totalCount
) => {
	return [
		{
			headerName: `Vendors (${totalCount})`,
			field: 'vendorName',
			colId: 'vendorName',
			minWidth: 190,
			sortable: true,
			...(sortModel && sortModel.colId === 'vendorName'
				? { sort: sortModel.sort }
				: {}),
		},
		{
			headerName: 'Total spend',
			field: 'spend',
			colId: 'spend',
			type: 'numericColumn',
			headerClass: 'ag-numeric-header',
			cellStyle: { textAlign: 'right' },
			minWidth: SPEND_COL_MIN_WIDTH,
			sortable: true,
			...(sortModel && sortModel.colId === 'spend'
				? { sort: sortModel.sort }
				: {}),
			valueFormatter: params => spendFormatter(params.value),
		},
		...companies.map((companyName, index) => ({
			headerName: companyName,
			colId: companyName,
			type: 'numericColumn',
			headerClass: 'ag-numeric-header',
			cellStyle: { textAlign: 'right' },
			minWidth: SPEND_COL_MIN_WIDTH,
			sortable: true,
			...(sortModel && sortModel.colId === companyName
				? { sort: sortModel.sort }
				: {}),
			valueGetter: params => {
				return (
					params &&
					params.data &&
					params.data.companies &&
					params.data.companies[index]
				);
			},
			valueFormatter: params => {
				return params.value
					? `${spendFormatter(params.value)} (${Math.round(
							(params.value / params.data.spend) * 100
					  )}%)`
					: '-';
			},
		})),
		{
			headerName: 'Top L4 category',
			field: 'l4Category',
			minWidth: 140,
			width: 140,
			cellClass: 'categories-column',
		},
		{
			headerName: '',
			field: 'l4Category',
			minWidth: 40,
			width: 40,
			lockVisible: true,
			cellRenderer: 'categoriesCellRenderer',
		},
	];
};
